module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABTUlEQVQ4jZ2UPUvEQBCGn4iFdoK2In6wdmJjI3b2rmgrFoIpbLzKnyCeYGe1FiqHgo2w5yFYCoeVcJWC8S9oYWF1aiS4OXPhdrOXFwKzO/M+O5MNCcgojuPOQkZhDdigt061UFtpJgj+MQMWQ6JxR27KlujqcOVlWwBVs78EjFp870AzGQrYq8+evKaJwVzhHLDq6CxVcpA08QXQAbpGLiUfYBtYACYzz7GtOD9yL11qoR7TfRmFy8COrdinw8MMbAK4cvmKgA0t1LOBDQHXjpv3AlYz8QEwDXwAn2WAD1qoZrrQQlW0UCOmwzubyXUpDRmF8yZ+0kK1TXwErJXpcB9oAXXgm7/3WAF2HR6vWz7TQv3IKFw33TnlAzyXUbgI1HzqiwruTY0Ghj0OLwTeALfAmA+sCPgFbAIzvrAiYPJJJb+zvpQHvvUL6PIAv+HhR5/4LZF2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/alarmList/list_icon_voltage.png
// module id = ZwVZ
// module chunks = 1